import "../css/app.css";

import Swiper from "swiper";
import { EffectFade } from "swiper/modules";
import Choices from "choices.js";

window.Swiper = Swiper;
window.EffectFade = EffectFade;
window.Choices = Choices;
